import { WorkingSettingsStep } from "../../../assets/utils/enums/settings";

export const onboardingSteps: WorkingSettingsStep[] = [
  {
    id: 1,
    path: "name",
    title: "Назва CRM",
    subtitle: "Назвіть вашу CRM-систему",
  },
  {
    id: 2,
    path: "plan",
    title: "План підписки",
    subtitle: "Оберіть план",
  },
  {
    id: 3,
    path: "structure",
    title: "Структура",
    subtitle: "Виберіть шаблон системи",
  },
  {
    id: 4,
    path: "finish",
    title: "Завершення",
    subtitle: "CRM готова до роботи",
  },
];
